import styled from 'styled-components';
import { PopoverBody } from '@aag-development/becreatives-ui';

const StyledPopoverBody = styled(PopoverBody)``;

export { StyledPopoverBody };
